import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
//import { Network } from '@ionic-native/network';
import { HttpModule } from '@angular/http';

import { MyApp } from './app.component';
import { RcsAppConfig } from '../assets/app.config';

// Component
import { RcsKdQuotationEditComponent } from '../components/rcs-kd-quotation-edit/rcs-kd-quotation-edit';
import { RcsKdProductSearchComponent } from '../components/rcs-kd-product-search/rcs-kd-product-search';

// Provider
import { RcsKdDataServiceProvider } from '../providers/rcs-kd-data-service/rcs-kd-data-service';
import { RcsConnectorOdooProvider } from '../providers/rcs-connector-odoo/rcs-connector-odoo';
import { RcsConnectorIndexDbProvider } from '../providers/rcs-connector-index-db/rcs-connector-index-db';
import { RcsStackProvider } from '../providers/rcs-stack-service/rcs-stack-service';
import { RcsStackDbProvider } from '../providers/rcs-stack-db-service/rcs-stack-db-service';
import { RcsSyncDataProvider } from '../providers/rcs-sync-data-service/rcs-sync-data-service';
import { RcsLoginProvider } from '../providers/rcs-login-service/rcs-login-service';
import { RcsInstallServiceProvider } from '../providers/rcs-setup-service/rcs-install-service';
import { RcsStartupServiceProvider } from '../providers/rcs-setup-service/rcs-startup-service';
import { ReplacementPartsProvider } from '../providers/replacement-parts/replacement-parts';

// Modal
import { RcsModalEstimateline } from '../components/rcs-modal-estimateline/rcs-modal-estimateline';
import { RcsModalWorkline } from '../components/rcs-modal-workline/rcs-modal-workline';

// Module
import { JobPageModule } from '../pages/job/job.module';
import { CalenderPageModule } from '../pages/calender/calender.module';
import { ComponentsModule } from '../pages/components.module';
import { JobImplementationModule } from '../pages/job-implementation/job-implementation.module';
import { ReplacementPartsPageModule } from '../pages/replacement-parts/replacement-parts.module';
import { SyncProductsProvider } from '../providers/rcs-sync-data-service/sync-products.service';
import { SignaturePadModule } from 'angular2-signaturepad';
import { CalenderMonthPageModule } from '../pages/calender-month/calender-month.module';
import { DraftServiceProvider } from '../providers/draft-service/draft-service';
import { JobCommitProvider } from '../providers/job-commit/job-commit';
import { StackService } from "../providers/odoo/stack.service";

@NgModule({
  declarations: [
    MyApp,
    RcsKdQuotationEditComponent,
    RcsKdProductSearchComponent,
    RcsModalEstimateline,
    RcsModalWorkline,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    JobPageModule,
    CalenderPageModule,
    ComponentsModule,
    JobImplementationModule,
    ReplacementPartsPageModule,
    SignaturePadModule,
    CalenderMonthPageModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    RcsModalEstimateline,
    RcsModalWorkline
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    RcsAppConfig,
    RcsKdDataServiceProvider,
    RcsConnectorOdooProvider,
    RcsConnectorIndexDbProvider,
    RcsStackProvider,
    RcsStackDbProvider,
    RcsSyncDataProvider,
    RcsLoginProvider,
    RcsInstallServiceProvider,
    RcsStartupServiceProvider,
    ReplacementPartsProvider,
    SyncProductsProvider,
    DraftServiceProvider,
    JobCommitProvider,
    StackService,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts